/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { ChangeEvent, useEffect } from 'react'
import { IInputProps } from '../../../types/interfaces/IInputProps'
import { InputContainer, Input, Label } from '../input/style'
import { Error } from '../error/Error'
import { useAppSelector } from 'store/store'

export const IdInput: React.FC<IInputProps> = ({
  callback,
  hasError,
  errorText,
  className,
  value,
  disabled,
  labelText,
}) => {
  const isLoading = useAppSelector((state) => state.layout.isLoading)

  useEffect(() => {
    if (value) {
      handleValueChange(value)
    }
  }, [])

  const handleValueChange = (value: string) => {
    const error = !isIsraeliIdNumber(value)
    callback(value, error)
  }

  const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
    e.preventDefault()
    handleValueChange(e.target.value)
  }

  return (
    <InputContainer className={`${className ?? ''} ${hasError ? 'error' : ''}`}>
      <Label htmlFor="id">{labelText}</Label>
      <Input
        title={disabled ? 'לא ניתן לערוך שדה זה' : ''}
        disabled={disabled || isLoading}
        value={value}
        type="number"
        name="id"
        onChange={(e: ChangeEvent<HTMLInputElement>) => handleChange(e)}
      ></Input>
      <Error hasError={hasError} errorText={errorText}></Error>
    </InputContainer>
  )
}

const isIsraeliIdNumber = (id: string): boolean => {
  // Step 1: ensure the ID is a string
  id = String(id)

  // Step 2: Ensure the ID is exactly 9 characters long
  if (id.length !== 9) {
    return false
  }

  // Step 3: Pad with leading zeros if necessary
  id = id.padStart(9, '0')

  // Step 4: If the ID consists of all zeros, it's invalid
  if (/^0+$/.test(id)) {
    return false
  }

  // Step 5: Define weights
  const weights = [1, 2, 1, 2, 1, 2, 1, 2, 1]

  // Step 6: Calculate weighted sum of digits
  const sum = Array.from(id, Number).reduce((counter, digit, i) => {
    const step = digit * weights[i]
    return counter + (step > 9 ? step - 9 : step)
  }, 0)

  // Step 7: Check if the sum is divisible by 10
  return sum % 10 === 0
}
